module.exports = __webpack_public_path__ + "media/img/frontend_application/homepage_reward_mobile-fb6766a6f99edc320487075e59908bbe.png";